module.exports = __webpack_public_path__ + "static/media/checklist.872b6e79.svg";